import {
    SET_LP_DASHBOARD_SIDEBAR_VISIBILITY,
    SET_UPCOMING_EVENTS,
    SET_RECENT_ACTIVITY,
    SET_COURSE_MENTORS,
    SET_COURSE_AUTHORS,
    SET_GROUP_MEMBER_DATA,
    SET_SECTION_ID,
    SET_LP_LICENSES,
    SET_ONLINE_USERS,
} from '../../constants';
import { fromJS } from 'immutable';


const INITIAL_STATE = fromJS({
    liveProjectData: {
        isDashboardSideBarVisible: true,
    }

});



function liveProjectReducer(state = INITIAL_STATE, action =
    {
        type: '',
        isDashboardSideBarVisible: true,
        upcomingEvents: null,
        recentActivityLog: null,
        courseMentors: null,
        courseAuthors: null,
        groupMemberData: null,
        sectionId: null,
        lPLicenses: null,
        onlineUsers: null,
    }) {

    switch (action.type) {
        case SET_LP_DASHBOARD_SIDEBAR_VISIBILITY:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    isDashboardSideBarVisible: action.isDashboardSideBarVisible,
                })),
            }));
        case SET_UPCOMING_EVENTS:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    upcomingEvents: action.upcomingEvents,
                })),
            }));
        case SET_RECENT_ACTIVITY:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    recentActivityLog: action.recentActivityLog,
                })),
            }));
        case SET_COURSE_MENTORS:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    courseMentors: action.courseMentors,
                })),
            }));
        case SET_COURSE_AUTHORS:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    courseAuthors: action.courseAuthors,
                })),
            }));
        case SET_GROUP_MEMBER_DATA:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    groupMemberData: action.groupMemberData,
                })),
            }));
        case SET_ONLINE_USERS:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    onlineUsers: action.onlineUsers,
                })),
            }));
        case SET_SECTION_ID:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    sectionId: action.sectionId,
                })),
            }));
        case SET_LP_LICENSES:
            return state.merge(fromJS({
                liveProjectData: state.get('liveProjectData').merge(fromJS({
                    lPLicenses: action.lPLicenses,
                })),
            }));

        default:
            return state;
    }
}


export default liveProjectReducer;
